import { PropertyDataCivil } from './components';

export const StepTwo = () => <PropertyDataCivil />;
